<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('RailwayExport.AdjustmentOperation')"
    width="1000px"
    :close-on-click-modal="false"
    class="app-main-inner"
  >
    <div class="app-main-row">
      <el-form :inline="true" label-width="60px" label-position="left">
        <el-form-item :label="$t('RailwayExport.EQSize')">
          <cargo-advance-select
            no="cSize"
            :select-type="TYPE_NAMES.local_cache_EQSize3"
            :fields="['code']"
            filterable
            :default-value="filter.cSize"
            tag-name="code"
            placeholder="ALL"
            @parentCallBack="p=>{filter.cSize=p.value}"
          />
        </el-form-item>
        <el-form-item :label="$t('RailwayExport.EQType')">
          <cargo-advance-select
            no="cType"
            :select-type="TYPE_NAMES.basic_data_EQType"
            :fields="['code']"
            filterable
            :default-value="filter.cType"
            tag-name="code"
            placeholder="ALL"
            @parentCallBack="p=>{filter.cType=p.value}"
          />
        </el-form-item>
        <el-form-item :label="$t('RailwayExport.ContainerType')">
          <el-select v-model="filter.containerType" no="containerType" :placeholder="$t('RailwayExport.All')" @change="filter.cQ=0">
            <el-option
              v-for="(item,index) in ORDER_TYPE_LISTS"
              :key="index"
              :label="item.chineseName"
              :value="item.code"
            />
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('RailwayExport.Term')">
          <div style="display: flex;flex-direction: row;">
            <el-input-number
              v-model="filter.cQ"
              no="cQ"
              :disabled="filter.containerType!=='3'"
              :precision="0"
              :controls="false"
              :min="0"
              style="margin-right: 2px;"
            />{{ $t('RailwayExport.Days') }}
          </div>
        </el-form-item>
      </el-form>
    </div>
    <div class="app-main-row">
      <el-form :inline="true" label-width="60px" label-position="left">
        <el-form-item :label="$t('RailwayExport.UnitPriceInterval')">
          <el-input-number v-model="filter.amountS" no="amountS" :precision="2" :controls="false" :min="0" />
        </el-form-item>
        <el-form-item label="~">
          <el-input-number v-model="filter.amountE" no="amountE" :precision="2" :controls="false" :min="0" />
        </el-form-item>
        <el-form-item :label="$t('RailwayExport.CurrencyCode')">
          <cargo-advance-select
            no="currencyCode"
            :select-type="TYPE_NAMES.basic_data_Currency"
            :fields="['code']"
            filterable
            :default-value="filter.currencyCode"
            tag-name="code"
            placeholder="ALL"
            @parentCallBack="p=>{filter.currencyCode=p.value}"
          />
        </el-form-item>
      </el-form>
    </div>
    <div class="app-main-row">
      <el-form>
        <el-form-item>
          <el-button no="Query" type="primary" @click="toQuery">{{ $t('CargoMsg.Cargo_Query') }}</el-button>
          <el-button no="Empty" type="primary" @click="reset">{{ $t('CargoMsg.Cargo_Empty') }}</el-button>
        </el-form-item>
      </el-form>
    </div>
    <cargo-ag-grid
      :grid-options="gridOptions"
      :column-defs="columnDefs"
      :row-data="rowData"
      style="width: 100%;height: 300px"
      @gridReady="params=>{gridApi=params.api}"
    />
    <span slot="footer">
      <el-button no="Confirm" type="primary" @click="successHandler">{{ $t('CargoMsg.Cargo_ConfirmR') }}</el-button>
      <el-button no="Cancel" @click="innerVisible=false">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import ColumnUtils from '@/utils/ColumnUtils'
import * as BoxTubeConstants from '@/class/cargo/model/parameters/BoxTubeConstants'
import { queryAvailableContainerList, checkCallContainer, saveCallContainer } from '@/api/railwayExport/railwayContainer'

export default {
  name: 'CallContainerDialog',
  components: { cargoAdvanceSelect },
  props: {
    visible: { type: Boolean, required: true },
    job: { type: Object, required: true }
  },
  data() {
    return {
      innerVisible: false,
      filter: {
        cSize: '',
        cType: '',
        containerType: '',
        cQ: 0,
        amountS: undefined,
        amountE: undefined,
        currencyCode: ''
      },
      rowData: []
    }
  },
  watch: {
    visible: {
      handler(newVal) {
        this.innerVisible = newVal
        if (newVal) {
          this.toQuery()
        }
      },
      immediate: true
    },
    innerVisible(newVal) {
      if (!newVal) {
        for (const key in this.filter) {
          if (typeof this.filter[key] === 'number') {
            this.filter[key] = 0
          } else {
            this.filter[key] = ''
          }
        }
        this.rowData = []
      }
      this.$emit('update:visible', newVal)
    }
  },
  created() {
    this.TYPE_NAMES = TYPE_NAMES
    this.ORDER_TYPE_LISTS = BoxTubeConstants.ORDER_TYPE_LISTS
    this.gridOptions = {
      rowSelection: 'multiple',
      suppressCellSelection: true,
      onRowDataChanged: event => {
        // 清除单选行
        event.api.clearFocusedCell()
      },
      context: {
        componentParent: this
      }
    }
    this.columnDefs = [
      {
        headerName: '',
        field: '',
        headerCheckboxSelection: true,
        checkboxSelection: true,
        sortable: false,
        suppressMenu: true,
        suppressSizeToFit: true,
        resizable: false
      },
      {
        headerName: this.$t('RailwayExport.ContainerNo'),
        field: 'CONTAINERNO',
        width: 150
      },
      {
        headerName: this.$t('RailwayExport.EQSize'),
        field: 'EQSIZE',
        width: 150
      },
      {
        headerName: this.$t('RailwayExport.EQType'),
        field: 'EQTYPE',
        width: 150
      },
      {
        headerName: this.$t('RailwayExport.BoxOwner'),
        field: 'SELLER_NAME',
        width: 150
      },
      {
        headerName: this.$t('RailwayExport.ContainerType'),
        field: 'ORDER_TYPE',
        width: 150,
        cellRenderer: params => {
          const orderType = BoxTubeConstants.getOrderTypeByCode(params.value)
          return orderType ? orderType.chineseName : ''
        }
      },
      {
        headerName: this.$t('RailwayExport.UnitRate'),
        field: 'UNIT_PRICE',
        width: 150
      },
      {
        headerName: this.$t('RailwayExport.CurrencyCode'),
        field: 'CURRENCY_CODE',
        width: 100
      },
      {
        headerName: this.$t('RailwayExport.RentDate'),
        field: 'RENT_DATE',
        width: 100,
        cellRenderer: params => {
          return ColumnUtils.formateDateToString(params.value, 'yyyy-MM-dd')
        }
      },
      {
        headerName: this.$t('RailwayExport.ReturnTime'),
        field: 'RETURN_DATE',
        width: 150,
        cellRenderer: params => {
          return ColumnUtils.formateDateToString(params.value, 'yyyy-MM-dd')
        }
      }
    ]
    this.gridApi = null
  },
  methods: {
    toQuery() {
      const params = {}
      const filter = this.filter
      if (filter.cSize) {
        params.cSize = filter.cSize
      }
      if (filter.cType) {
        params.cType = filter.cType
      }
      if (filter.containerType > 0) {
        params.containerType = filter.containerType
      }
      if (filter.cQ > 0) {
        params.cQ = filter.cQ
      }
      if (filter.amountS > 0) {
        params.amountS = filter.amountS
      }
      if (filter.amountE) {
        params.amountE = filter.amountE
      }
      if (filter.currencyCode) {
        params.currencyCode = filter.currencyCode
      }
      queryAvailableContainerList(params).then(res => {
        this.rowData = res.data
      })
    },
    reset() {
      for (const key in this.filter) {
        if (typeof this.filter[key] === 'number') {
          this.filter[key] = 0
        } else {
          this.filter[key] = ''
        }
      }
    },
    successHandler() {
      const rows = this.gridApi.getSelectedRows()
      const branchId = this.$store.getters.currentOfficeId
      const currentDept = this.$store.getters.currentDept
      const departmentId = currentDept ? currentDept.departmentId : ''
      checkCallContainer(rows, this.job.uuid).then(res => {
        const data = res.data
        if (data.result === 2) {
          this.$message.info(data.resultMessage)
        } else if (data.result === 1) {
          this.$confirm(data.resultMessage, this.$t('Message.Prompt'), {
            confirmButtonText: this.$t('common.btn.ok'),
            cancelButtonText: this.$t('common.btn.cancel'),
            type: 'warning'
          }).then(() => {
            saveCallContainer(rows, this.job.uuid, branchId, departmentId).then(res => {
              if (res.data > 0) {
                this.$emit('successCallback')
                this.$message.success(this.$t('Message.SuccessfulBoxAdjustment') + '：' + res.data)
              } else {
                this.$message.info(this.$t('Message.NoBoxesProcessedSuccessfully'))
              }
              this.innerVisible = false
            })
          }).catch(() => { })
        } else {
          saveCallContainer(rows, this.job.uuid, branchId, departmentId).then(res => {
            if (res.data > 0) {
              this.$emit('successCallback')
              this.$message.success(this.$t('Message.SuccessfulBoxAdjustment') + '：' + res.data)
            } else {
              this.$message.info(this.$t('Message.NoBoxesProcessedSuccessfully'))
            }
            this.innerVisible = false
          })
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
#app .app-main-inner .app-main-row ::v-deep {
  .el-form-item__content {
    width: 160px;
    .el-input-number--mini {
      width: 100%;
    }
  }
}
</style>
